<div [class]="mobApp">
    <div class="iframe-container">
        <iframe style="height: 100%; width: 100%" [src]="urlSafe" frameborder="0"
        #iframe allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>
    </div>
</div>